<template>
  <div>
    <div>
      <img src="@/assets/images/contactus.png" alt="" style="width:100%" />
    </div>
    <div class="topss">
      <img src="@/assets/images/contact.png" alt="" />
    </div>
    <div class="middless">
      <div id="container" class="container"></div>
    </div>
    <div class="middless-font">联系方式:</div>
    <div class="bottomss">
      <div>
        <p>咨询电话:13348887787(郑先生)</p>
        <!-- <p>13540092309(苏先生);</p> -->
        <p>15982842789(董先生)</p>
      </div>
    </div>
    <div class="code-two">
      <div class="code-font">
        <div>
          <p>
            扫码关注<br />
            融畅易和
          </p>
          <p>成都融畅易和 科技有限公司</p>
        </div>
        <img src="@/assets/images/code.jpg" alt="" />
      </div>
    </div>
    <IndexFooter></IndexFooter>
    <work-order></work-order>
  </div>
</template>

<script>
import IndexFooter from "../components/IndexFooter.vue";
import WorkOrder from "../components/WorkOrder.vue";
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  securityJsCode: "053857b62aa77d770c6cfefccf43e265", //你的秘钥
};
export default {
  name: "",
  props: {},
  data() {
    return {
      // 地图实例
      map: null,
      // 标记点
      marker: "",
      // 地址逆解析
      geoCoder: null,
      infoWindow: "",
      // 位置信息
      form: {
        lng: 104.189327,
        lat: 30.551058,
        address: "",
        //地区编码
        adcode: "",
      },
    };
  },
  components: { IndexFooter, WorkOrder },
  methods: {
    initMap() {
      AMapLoader.load({
        key: "26143722eb877920ca0ca1f78cb337c2", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.Geocoder",
          "AMap.AutoComplete",
          "AMap.Marker",
          "AMap.InfoWindow",
        ],
        resizeEnable: true,
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            viewMode: "", //是否为3D地图模式
            zoom: 5, //初始化地图级别
            center: [104.189327, 30.551058], //初始化地图中心点位置
          });
          this.geoCoder = new AMap.Geocoder({
            city: "010", //城市设为北京，默认：“全国”
            radius: 1000, //范围，默认：500
          });
          // 清除点
          this.removeMarker();
          // 标记点
          this.setMapMarker();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 逆解析地址
    toGeoCoder() {
      let lnglat = [this.form.lng, this.form.lat];
      this.geoCoder.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.regeocode) {
          this.form.address = result.regeocode.formattedAddress;
        }
      });
    },
    // 标记点
    setMapMarker() {
      this.infoWindow = new AMap.InfoWindow({
        anchor: "top-left",
        offset: new AMap.Pixel(0, -30),
      });
      // 自动适应显示想显示的范围区域
      this.map.setFitView();
      this.marker = new AMap.Marker({
        map: this.map,
        position: [this.form.lng, this.form.lat],
      });
      let content =
        '<ul style="  margin:-10px 0 5px 0; padding:0.2em 0;">' +
        '<li style="line-height:26px; font-size:14px;color:#727272;margin-bottom:6px">' +
        '<span style="width:50px; display:inline-block;">名 称：</span>' +
        "成都融畅易和科技有限公司" +
        "</li>" +
        '<li style="font-size:14px;color:#727272;">' +
        '<span style="width:50px; display:inline-block;" >地 址：</span>' +
        "成都市龙泉驿区经开区南二路309号鼎峰动力港12栋7单元6楼" +
        "</li>" +
        "</ul>";
      this.marker.content = content;
      this.marker.on("click", this.markerClick);
      this.marker.emit("click", { target: this.marker }); // 此处是设置默认出现信息窗体
      // 逆解析地址
      this.toGeoCoder();
      this.map.setFitView();
      this.map.add(this.marker);
    },
    // 清除点
    removeMarker() {
      if (this.marker) {
        this.map.remove(this.marker);
      }
    },
    markerClick(e) {
      // 标注的点击事件
      this.infoWindow.setContent(e.target.content);
      this.infoWindow.open(this.map, e.target.getPosition());
    },
  },
  mounted() {
    this.initMap();
  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss'>
.topss {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 109px;
}
.middless {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 85px;
}
.adress {
  width: 150px;
  position: absolute;
  font-size: 11px;
  left: 50.5%;
  top: 132%;
  z-index: 99999999;
}
.middless-font {
  margin-left: 20%;
  margin-top: 97px;
  width: 125px;
  height: 30px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #19202a;
  line-height: 86px;
}
.container {
  width: 1245px;
  height: 336px;
}
.bottomss {
  margin-left: 20%;
  margin-top: 24px;
  div {
    display: flex;
    p {
      width: 30%;
      height: 21px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 86px;
    }
  }
}
.code-two {
  width: 100%;
  display: flex;
  justify-content: center;
  .code-font {
    margin-top: 107px;
    margin-bottom: 50px;
    width: 271px;
    height: 138px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    div {
      margin-left: 30px;
      p {
        width: 85px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
      }
      p:nth-of-type(2) {
        width: 80px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin-top: 10px;
      }
    }
    img {
      width: 103px;
      height: 103px;
      margin-right: 35px;
    }
  }
}
</style>